export default __webpack_public_path__ + "static/media/ic-calendar.86c06750.svg";